import React from "react";
export const SemaVeBisikletDescription = (props: any) => {
    return (
        <div>
            <p>
                Sufi öğretisi üzerine <span className="highlight-word">SEMA</span> törenine hazırlanırken bir şeyi öğrenmiştik: Sufilikte sormadan hiçbir şey olmuyor.
                Kim soru sormazsa cevap da almıyor. “Her defasında tekrar tekrar sorun!” denildiğini duyuyorduk. Burada her
                türlü soruya bir cevap alındığı anlamı çıkmamalıdır. Sorular elbette ki belirli nitelikleri taşımalıdır.
                Sadece merak ve basit bilgi ihtiyacından doğan sorular, daha başlangıçtan itibaren cevaplandırılan soruların
                dışında kalıyor. Bu tür sorular cevaplansa da, gecikmeli ve istenmeyerek cevaplandırılıyor. Peki, geriye hangi
                tür sorular kalıyor? Sorular, kalpten gelen sorular olmalıdır. Cevabını buluncaya kadar bir ömür boyunca
                sorulan sorular. Ve cevaplandırılmasıyla belirli şartlarda hayatı baş aşağı çeviren sorular.
            </p>
        </div>
    )
}

export const SufininNotDefteriDescription = (props: any) => {
    return (
        <div>
            <p>
                Sufilik geleneğinin öğretisi üzerine müstevhid olduğum sohbetler, aydınlandığımız eserler, Kur’an ve Hadis
                ışığında, şahsi araştırmalarım ve 40 yıllık bir dervişin not defterinden böyle bir eserin hazırlanması
                büyüklerin de himmetiyle zuhur etmiştir. Allah’a hamdolsun. Mürşid-i Azizimiz Muzaffer Aşki Rahmetullahi
                Aleyh, manevi 19 Nisan 1974’te doğuşumuzu tasdik buyurararak, “Sizi bize Ahmed ism-i şerifi hürmetine
                gönderdiler.” dediler. Tasavvuf neşesi içerisinde o andaki aşkımızın, şevkimizin ziyade olması, “birine ikrar
                binine hizmet gayesi” devam ederken 1976 yılında Celaleddin Bakır Çelebi Efendi (21 nci kuşaktan Hz.
                Mevlâna’nın torunu), Muzaffer Aşki Rahmetullahi aleyh Hazretlerinin kütüphanesine gelerek hal hatır sorduktan
                sonra:
            </p>
        </div>
    )
}

export const SemaSonHaliDescription = (props: any) => {
    return (
        <div>
            <p>
                Sultanü’l-Ulema, Mevlana, Hüsameddin Çelebi ve Sultan Veled müderris bulundukları medresenin bir odasında
                diledikleri vakit zikrederler, başka tekkelerin ayinlerine katılırlar, evlerde sema, sohbet meclisleri
                kurarlardı, kendikerine mahsus tekkeleri yoktu. Sayıları 10 kişiyi geçmezdi. İlk defa Ulu Arif Çelebi
                dedesinin türbesinde uzlete çekilmesiyle, mevlevihanenin nüvesi meydana atılmış oldu. Mevleviliğin en önemli
                esası SEMA’dır. Yukarıda izah edilmeye çalışıldığı gibi Hz. Mevlâna zamanında SEMA, bir dost toplantısı, bir
                yemek meclisi evvelinde veya sonunda, kulağa gelen hoş ve manalı bir ses veya heyecanlı bir hadise neticesinde
                ortaya çıkan VECD hali idi. Bu devirlerde muhtelif hadiselerin tesirleri ile SEMA’nın yanında, bir musiki
                heyetinin de refakati ile toplu halde ve çoğu zamanda tesadüfe bağlı SEMA’da yapılırdı. Kaynaklarda bu şekilde
                icra edilen SEMA’nın teferruatına rastlanmaz. Ancak bazı kayıtlardan bilhassa Mevlâna’nın medresesinde yapılan
                SEMA da musiki heyetine ayrılan yüksekçe bir yer bulunduğu Mevlâna’nın tamamen erkeklerden müteşekkil olan bu
                heyetin önünde SEMA ettiği olmuştur. Yine SEMA’nın sonraki şeklinde görülen selam verme âdetinin izlerine de
                rastlanmaktadır.
            </p>
        </div>
    )
}